import React, { useEffect, useState, useReducer } from 'react';
import { Link } from "react-router-dom";

import {_getCoutryGoogleChartName} from '../../helpers/helpers.js'

import ScanDomainTechnologies from '../../components/scanTechnologyList.js'
import StartMonitoring from '../../components/startMonitoringButton.js';

import {APIResponse} from '../../../../server/routes/route-types.js'
import {DomainInfo as RtDomainInfo, ProcessedTechnology, HydratedTechnology, ScanResultsPageResult, ScanStatusResponse} from '../../../../server/routes/technology-scan.js'

interface ScanState {
    status: string;
    domainInfo: RtDomainInfo | null;
    technologies: HydratedTechnology[] | null;
    advertisers?: ProcessedTechnology[] | null;
    explanation: string;
}

type ReducerAction = [string, wts_approved_any];


export default function ScanResults({ server, pageData }: { server: string; pageData: unknown }) {

	let [data, setData] = useState(pageData as ScanResultsPageResult);

	const domain: string = data.Domain;

	return (
		<>
			 <section className="section section-sm">
				<h3 className="text-left mb-3">
				<b>Technology Stack Report</b>
				</h3>
				for website <b>{domain}</b>
				<WebsiteScanResult  props={data}  /> 
			</section>
   
		</>
	)
}

function WebsiteScanResult({ props }: { props: ScanResultsPageResult }) {

	if (!props.Domain) return  (<></>);
	if (!props.ScanId) return  (<></>);

	const domain: string = props.Domain;
	const scanId: string = props.ScanId;

	const [scanState, setScanState] = useState<number>(props.ScanResults && props.ScanResults.status === 'completed' ? 0 : 1);
	const [state, dispatch] = useReducer(
		WebsiteScanFormReducer, getStateFromResults(props.ScanResults));

	useEffect(() => {
		if (scanState) { 
		  const intervalId = setInterval(() => {
			fetchScanResult(scanId);
		  }, 2000); // Refresh every 2 seconds
	
		  return () => clearInterval(intervalId);
		}
	}, [scanState]);	

	function getStateFromResults(results: ScanStatusResponse): ScanState {
		if (!results) return {			
			status: "Scheduling",
			domainInfo: null,
			technologies: null,
			explanation: "N/A"
		};

		if (results.status === "running") {					
			return {
				status: 'Scan in progress',
				domainInfo: null,
				technologies: null,
				advertisers: null,
				explanation: "N/A",
			}; 
		}
		else if (results.status === "completed") {
			let tech: HydratedTechnology[] = [];

			if (results.technologies) {	
				tech = results.technologies.sort(
					(a: HydratedTechnology, b: HydratedTechnology) => compareTechByCategory(a, b));
			}			
			return  {
				status: "Completed",
				domainInfo: results.domainInfo || null,
				technologies: tech,
				advertisers: results.advertisers,
				explanation: "Live Scan completed."
			};  
		} 				
		else if (results.status === "failed") {
			return {
				status: results.error || "Failed",
				domainInfo: null,
				technologies: results.technologies || null,
				advertisers: results.advertisers,
				explanation: results.error || "Failed"
			};  
		} 		
		return {			
			status: "Scheduling",
			domainInfo: null,
			technologies: null,
			explanation: "N/A"
		};
	}
	function processScanResults(results: ScanStatusResponse): void {
		if (!results) return;

		let state: ScanState = getStateFromResults(results);

		if (results.status === "running") {	
			if (scanState > 300) {
				// 10 minute : 600 sec / 2
				setScanState(0);					
				dispatch([ "error", {
					status: "Scan timeout"
				}]); 	
			} else {
				setScanState(scanState + 1);					
				state.status += ' ';
				for (let i: number = 0; i < scanState; i++) state.status += '.';
				dispatch([ "success", state]); 
			}
		}
		else if (results.status === "completed") {
			setScanState(0);
			dispatch([ "success", state]);  
		} 				
		else if (results.status === "failed") {
			setScanState(0);
			dispatch([ "success", state]);  
		} 
	}

	function fetchScanResult(scanId: string): void {
		var requestBody: string = JSON.stringify({
			domain
			});
		
	
		fetch(`/technology-scan/api-scan-results?scanid=${scanId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
			body: null
		}).then(( result ) => {
			return result.json();
		}).then(( untypedData : unknown) => {
			const data = untypedData as APIResponse<ScanStatusResponse>;
			if (data.err ) { 
				console.log(JSON.stringify(data));		
				setScanState(0);	
				if (data.result404 ) { 
					dispatch([ "error", {
						status: data.result404.title,
						explanation: data.result404.title
					}]); 
				} else {
					dispatch([ "error", {
						status: data.err,
						explanation: data.err
					}]); 
				}
			}
			else if (data.results) { 
				processScanResults(data.results);
			} else {
				console.log(JSON.stringify(data));
//				setScanState(false);
				setScanState(0);
				dispatch([ "error", {
					status: 'Failed',						
					technologies: null,
					advertisers: null,
					explanation: 'Live Scan failure'
				}]); 
			}
	
		}).catch(( e ) => {
			console.error( "Exception", e );
		});
	};   
	
	
	return (
		<>			
			<div className="row row-50">
			<div className="col-12">
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
					<tr>
							<td style={{ width: '30%' }}>Scan Status</td>
							<td style={{ width: '70%', color: 'darkgreen' }}>
								<b>{ state.status }</b>
							</td>
						</tr>																																																																														
					</tbody>
				</table>
				<DomainInfo domainInfo={state.domainInfo} />
				{
					!!state.technologies && !!state.technologies.length  && 
					<StartMonitoring domain={props.Domain} />
				}	
				<ScanDomainTechnologies technologies={state.technologies} link={props.CanonicalURL} />
			</div>
		</div>		
		</>
		)
}




const WebsiteScanFormReducer = function(state: ScanState, [type, data]: ReducerAction): ScanState {
	if( type === "error" ){
		return {
			...state,
			status: data.status,
			domainInfo: null,
			technologies: null,
			advertisers: null,
			explanation: data.explanation
		};
	};   
	if( type === "success" ){
		let tech: HydratedTechnology[] | null = null;

		if (data.technologies !== null) {	
			tech = data.technologies.sort(
				(a: HydratedTechnology, b: HydratedTechnology) => compareTechByCategory(a, b));
		}

		return {
			...state,
			status: data.status,
			domainInfo: data.domainInfo,
			technologies: tech,
			advertisers: data.advertisers,
			explanation: data.explanation
		};;
	};
	return state; 
};

function compareTechByCategory(a: HydratedTechnology | null, b: HydratedTechnology | null): number {
	// workaround null element
    if (a === null || b === null)
        return (a || '') < (b || '') ? -1 : 1;


    if (a.Category < b.Category)
        return -1;
    if (a.Category > b.Category)
        return 1;
    return 0;
}

function DomainInfo({ domainInfo }: { domainInfo: RtDomainInfo | null }) {

	if (!domainInfo) return null;
	if (!domainInfo.redirect) return null;

	return (
		<div className="row row-50">
			<div className="col-12">
				<p style={{ color: 'red' }}>
				Website redirects to <b>{domainInfo.redirect}</b>
				</p>
			</div>
		</div>
	)
}

